import { MouseEvent } from 'react';
import { analytics } from '@sendgrid/bloodhound';
import APIConfig from 'src/apiconfig';
import { getDatadogRumOptions } from '../datadog';
import Cookies from 'js-cookie';
import { initialPageLoad3rdPartyScriptsAllowed } from '../helpers/thirdPartyScripts';

// This is the old way of doing things and requires you to set a click event listener
// on a parent DOM element wrapping a lot of the elements you would like to track. This
// avoids writing a click handler per element by adding a data-analytics-event property with the
// event object you wish to pass through the .track() call
export const analyticsClickHandler = (evt: MouseEvent) => {
  const el = evt.target as Element;

  const analyticsDataRaw = el.getAttribute('data-analytics-event');
  let analyticsDataParsed;
  try {
    analyticsDataParsed = JSON.parse(analyticsDataRaw ?? '');
  } catch (err) {
    if (!(err instanceof SyntaxError)) {
      throw err;
    }
    analyticsDataParsed = {};
  }

  if (!analyticsDataParsed.event) {
    return;
  }

  return analytics.track(analyticsDataParsed);
};

const initialize = () => {
  if (!initialPageLoad3rdPartyScriptsAllowed()) {
    return;
  }
  const datadogRumConfiguration = getDatadogRumOptions();

  analytics.init({
    apiBaseUrl: APIConfig.host,
    segmentApiKey: APIConfig.segmentApiKey,
    datadogRum: datadogRumConfiguration,
  });
};

const identify = () => {
  if (!initialPageLoad3rdPartyScriptsAllowed()) {
    return;
  }

  const makoAuthToken = Cookies.get('mako_auth_token');
  analytics.identify({
    authToken: makoAuthToken,
  });
};

export const Analytics = {
  initialize,
  identify,
  analyticsClickHandler,
  configure: analytics.configure,
  track: analytics.track,
};
